import { all, spawn } from 'redux-saga/effects';
import watchCommonSaga from './common/saga';
import watchFeaturesMemberRegisterAuthSaga from './features/member/register/auth/saga';
import watchFeaturesMemberRegisterGeneralSaga from './features/member/register/general/saga';
import watchFeaturesMemberRegisterPermissionSaga from './features/member/register/permission/saga';
import watchFeaturesMemberRegisterNSModalSaga from './features/member/register/nsModal/saga';
import watchFeaturesMemberLoginSaga from './features/member/login/saga';
import watchFeaturesMemberReauthSaga from './features/member/reauth/saga';
import watchFeaturesMemberSettingsEmailSaga from './features/member/settings/email/saga';
import watchFeaturesMemberSettingsMobileSaga from './features/member/settings/mobile/saga';
import watchFeaturesMemberSettingsPassPhraseSaga from './features/member/settings/passPhrase/saga';
import watchFeaturesMemberForgetSaga from './features/member/forget/saga';
import watchFeaturesInsureTravelInsuranceSaga from './features/insure/travelInsurance/saga';
import watchFeaturesServiceQueryPolicyDetailSaga from './features/service/queryPolicy/detail/saga';
import watchFeaturesServiceQueryPolicyPaySaga from './features/service/queryPolicy/pay/saga';
import watchFeaturesServiceQueryPolicyModifySaga from './features/service/queryPolicy/modify/saga';

export default function * rootSaga () {
  yield all([
    spawn(watchCommonSaga),
    spawn(watchFeaturesMemberRegisterAuthSaga),
    spawn(watchFeaturesMemberRegisterGeneralSaga),
    spawn(watchFeaturesMemberRegisterPermissionSaga),
    spawn(watchFeaturesMemberRegisterNSModalSaga),
    spawn(watchFeaturesMemberLoginSaga),
    spawn(watchFeaturesMemberReauthSaga),
    spawn(watchFeaturesMemberSettingsEmailSaga),
    spawn(watchFeaturesMemberSettingsMobileSaga),
    spawn(watchFeaturesMemberSettingsPassPhraseSaga),
    spawn(watchFeaturesMemberForgetSaga),
    spawn(watchFeaturesInsureTravelInsuranceSaga),
    spawn(watchFeaturesServiceQueryPolicyDetailSaga),
    spawn(watchFeaturesServiceQueryPolicyPaySaga),
    spawn(watchFeaturesServiceQueryPolicyModifySaga)
  ]);
};
